import { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useI18n } from '../i18n';

interface PaymentFormProps {
  onSuccess: (paymentIntentId: string) => void;
  onCancel: () => void;
}

export function PaymentForm({ onSuccess, onCancel }: PaymentFormProps) {
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useI18n();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);
    setError(null);

    const result = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    });

    if (result.error) {
      setError(result.error.message || 'Error');
      setProcessing(false);
    } else if (result.paymentIntent?.status === 'succeeded') {
      onSuccess(result.paymentIntent.id);
    } else {
      setError('Error');
      setProcessing(false);
    }
  }

  return (
    <form className="hc-stripe-form" onSubmit={handleSubmit}>
      <PaymentElement />
      {error && <div className="hc-form-error">{error}</div>}
      <div className="hc-stripe-actions">
        <button
          type="button"
          className="hc-btn hc-btn-secondary"
          onClick={onCancel}
          disabled={processing}
        >
          {t('checkout.back')}
        </button>
        <button
          type="submit"
          className="hc-btn hc-btn-primary"
          disabled={!stripe || processing}
        >
          {processing ? t('checkout.submitting') : t('checkout.submit')}
        </button>
      </div>
    </form>
  );
}
